// ISIC Rev.4 Industry Classification Codes
export const INDUSTRY_CODES = {
  A: 'Agriculture, forestry and fishing',
  B: 'Mining and quarrying',
  C: 'Manufacturing',
  D: 'Electricity, gas, steam and air conditioning',
  E: 'Water supply; sewerage, waste management',
  F: 'Construction',
  G: 'Wholesale and retail trade',
  H: 'Transportation and storage',
  I: 'Accommodation and food service',
  J: 'Information and communication',
  K: 'Financial and insurance activities',
  L: 'Real estate activities',
  M: 'Professional, scientific and technical',
  N: 'Administrative and support service',
  O: 'Public administration and defense',
  P: 'Education',
  Q: 'Human health and social work',
  R: 'Arts, entertainment and recreation',
  S: 'Other service activities',
  T: 'Activities of households as employers',
  U: 'Activities of extraterritorial organisations',
} as const;

export type IndustryCode = keyof typeof INDUSTRY_CODES;

export const INDUSTRY_OPTIONS = Object.entries(INDUSTRY_CODES).map(([code, label]) => ({
  value: code as IndustryCode,
  label: `${code}: ${label}`,
  shortLabel: label,
}));

// Utility functions
export const getIndustryLabel = (code: IndustryCode): string => {
  return INDUSTRY_CODES[code] || code;
};

export const getIndustryFullLabel = (code: IndustryCode): string => {
  return `${code}: ${INDUSTRY_CODES[code]}` || code;
};

export const validateIndustryCode = (code: string): code is IndustryCode => {
  return code in INDUSTRY_CODES;
};

export const validateIndustryCodes = (codes: string[]): IndustryCode[] => {
  return codes.filter(validateIndustryCode) as IndustryCode[];
};
